import { defineMessages } from 'react-intl';

export default defineMessages({
    CanNotLoadClaimInformation: {
        id: 'tdic.claimListComponent-details.Sorry we can not load your claim information at this time',
        defaultMessage: 'Sorry we can not load your claim information at this time'
    },
    claimRequestFailed: {
        id: 'tdic.claimListComponent-details-details.ERROR',
        defaultMessage: 'ERROR'
    }
});
